import { store } from 'store/configureStore';

export const getUserData = () => {
    return store.getState()?.user;
};
